export class Languages {
    static readonly spanish = 'es'
    static readonly english = 'en'
    static readonly portuguese = 'pt'

    static readonly defaultLanguage = Languages.spanish

    static readonly supportedLanguages = [Languages.spanish, Languages.english, Languages.portuguese]
}
